import { render } from "./Draggable.vue?vue&type=template&id=09d4f527&ts=true"
import script from "./Draggable.vue?vue&type=script&lang=ts"
export * from "./Draggable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__